import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileAlt,
  faBriefcase,
  faGraduationCap,
  faHeartPulse,
  faEnvelope,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";

const Careers = () => {
  const benefits = [
    {
      icon: faHeartPulse,
      title: "Mediu profesionist",
      description: "Lucru într-un mediu medical modern și profesionist",
    },
    {
      icon: faGraduationCap,
      title: "Dezvoltare profesională",
      description: "Oportunități de dezvoltare și perfecționare continuă",
    },
    {
      icon: faBriefcase,
      title: "Pachet salarial atractiv",
      description: "Pachet salarial competitiv și beneficii atractive",
    },
    {
      icon: faCheckCircle,
      title: "Echipă de suport",
      description: "Alătură-te unei echipe dedicate excelenței medicale",
    },
  ];

  return (
    <div className="careers-page">
      <section className="careers-hero">
        <div className="careers-overlay"></div>
        <div className="container">
          <div className="careers-hero-content">
            <h1>Dezvoltă-ți cariera alături de noi</h1>
            <p>
              Clinica noastră se extinde și căutăm profesioniști dedicați care
              împărtășesc viziunea noastră
            </p>
          </div>
        </div>
      </section>

      <section className="section careers-intro">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="careers-intro-content">
                <h2>Clinica noastră se extinde</h2>
                <p>
                  Clinica noastră se află într-o perioadă de extindere, iar
                  pentru a ne menține standardele înalte de calitate a
                  serviciilor, suntem în căutarea de{" "}
                  <strong>medici talentați și dedicați</strong>.
                </p>
                <p>
                  Oferta noastră include un pachet salarial competitiv,
                  beneficii și oportunități de dezvoltare profesională, într-un
                  mediu de lucru colaborativ și sprijinitor.
                </p>
                <p>
                  Suntem dedicați să oferim cele mai bune servicii medicale
                  posibile pacienților noștri, iar pentru asta avem nevoie de un
                  personal medical dedicat și talentat.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="careers-benefits">
                <h3>Ce oferim</h3>
                <div className="benefits-grid">
                  {benefits.map((benefit, index) => (
                    <div className="benefit-card" key={index}>
                      <div className="benefit-icon">
                        <FontAwesomeIcon icon={benefit.icon} />
                      </div>
                      <div className="benefit-content">
                        <h4>{benefit.title}</h4>
                        <p>{benefit.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section careers-apply">
        <div className="container">
          <div className="careers-apply-content">
            <div className="apply-icon">
              <FontAwesomeIcon icon={faFileAlt} />
            </div>
            <h2>Aplică acum</h2>
            <p>
              Dacă ești medic specialist în pneumologie sau altă specializare
              medicală și dorești să te alături echipei noastre, așteptăm cu
              drag CV-ul tău la adresa de e-mail:
            </p>
            <div className="apply-email">
              <FontAwesomeIcon icon={faEnvelope} />
              <a href="mailto:pneumotherapy@yahoo.com">
                pneumotherapy@yahoo.com
              </a>
            </div>
            <div className="apply-cta">
              <a href="mailto:pneumotherapy@yahoo.com" className="btn-apply">
                Trimite CV-ul tău
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;
